import InputUtils from "@bounce/shared/helpers/InputUtils";
import React, {ReactNode, useState} from "react";
import {S3_BASE_URL} from "@bounce/shared/constants";

interface CompanyLogoProps {
  companyName: string;
  size?: number;
  fallback?: ReactNode;
}

const CompanyLogo = ({companyName, size = 32, fallback}: CompanyLogoProps) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const fileName = `${InputUtils.toCompactLowerCase(companyName)}.webp`;

  if (error) return <>{fallback ?? null}</>;

  return (
    <div style={{width: size, height: size, flexShrink: 0}}>
      <img
        src={`${S3_BASE_URL}/bimi/${fileName}`}
        alt={`${companyName} logo`}
        onLoad={() => setLoaded(true)}
        onError={() => setError(true)}
        style={{
          width: size,
          height: size,
          objectFit: "contain",
          borderRadius: "8px",
          display: loaded ? "block" : "none",
        }}
      />
    </div>
  );
};

export default CompanyLogo;
